module.exports = __webpack_public_path__ + "img/JP.8b24c9f1.svg";